module.exports = __webpack_public_path__ + "static/media/img_20.a8b3bf98.png";